export const getErrorMessage = (error: unknown, fallback: string, context?: string) => {
  let message = fallback;
  if (typeof error === 'string' && error.trim()) message = error;
  else if (error instanceof Error) {
    const response = 'response' in error ? error.response : undefined;
    message =
      typeof response === 'string' && response.trim() ? response : error.message || fallback;
  }

  return context ? `${message} ${context}` : message;
};
